// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7039":"70989fb4","15991":"70989fb4","32082":"70989fb4","32535":"70989fb4","48539":"70989fb4","93934":"70989fb4","94347":"70989fb4"}[chunkId] + ".chunk.css";
};